<template>
  <div>
    <Tag
      type="dot"
      v-for="(item, index) in ipList"
      :key="index"
      :name="item"
      closable
      checkable
      color="primary"
      :disable-transitions="false"
      @on-close="handleClose(index)"
      v-show="ipList.length > 0"
    >
      {{ item }}
    </Tag>
    <Divider dashed v-show="ipList.length > 0" />

    <Form
      label-position="right"
      :model="formData"
      :label-width="90"
      :rules="ruleFrom"
      ref="formData"
      @submit.native.prevent
    >
      <FormItem :label="$t('ip')" prop="ip" v-if="inputVisible">
        <Input
          v-model="formData.ip"
          :placeholder="$t('enter') + $t('ip')"
          @on-enter="checkIp('formData')"
        ></Input>
      </FormItem>
      <Button v-else icon="md-add" type="dashed" @click="handleAdd">
        {{ $t("add") + $t("ip") }}
      </Button>
    </Form>
    <div class="footer-btn" style="margin: 10px -16px 0; padding: 12px 18px 0">
      <Button type="text" @click="close" style="margin-right: 8px">
        {{ $t("cancel") }}
      </Button>
      <Button type="primary" @click="save" :disabled="unChange">
        {{ $t("confirm") }}
      </Button>
    </div>
  </div>
</template>

<script>
import { getWhitelistDetail, updateWhitelist } from "@/api/user/whitelist";

export default {
  inject: ["$page"],
  props: {
    id: {
      type: Number
    },
    close: {
      type: Function
    }
  },
  watch: {
    ipList: {
      handler: function(nowVal) {
        var $this = this;
        for (let i in nowVal) {
          if (nowVal[i] !== $this.oldList[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      unChange: true,
      inputVisible: true,
      ipList: [],
      oldList: [],
      formData: {},
      ruleFrom: {
        ip: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("Ip cannot be empty"));
              }
              this.$nextTick(() => {
                var reg = /^((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])$/;
                if (!reg.test(value)) {
                  callback(new Error("The IP format is incorrect"));
                } else {
                  callback();
                }
              });
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    getWhitelistDetail(this.id).then(res => {
      this.ipList = res.data.payload.ips;
      this.oldList = JSON.parse(JSON.stringify(res.data.payload.ips));
      if (this.ipList.length == 0) {
        this.inputVisible = true;
      } else {
        this.inputVisible = false;
      }
    });
  },
  methods: {
    handleClose(index) {
      this.ipList.splice(index, 1);
      if (this.ipList.length == 0) {
        this.inputVisible = true;
      }
      this.unChange = false;
    },
    handleAdd() {
      this.inputVisible = true;
    },
    save() {
      if (this.ipList.length > 0) {
        this.$refs["formData"].resetFields();
      }
      let data = {
        client_id: this.id,
        ip_address: this.ipList
      };
      updateWhitelist(data).then(res => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg
        });
        if (res.data.status) {
          this.close();
          this.$page.getList();
        }
      });
    },
    checkIp(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let isEqual = false;
          this.ipList.some(item => {
            if (item == this.formData.ip) {
              isEqual = true;
            }
          });
          if (isEqual) {
            this.inputVisible = true;
            this.$Message["error"]({
              background: true,
              content: this.$t("re_enter")
            });
          } else {
            this.inputVisible = false;
            this.ipList.push(this.formData.ip);
            this.isDisabled = false;
          }
          this.formData.ip = "";
        } else {
          console.log(this.$t("fail"));
        }
      });
    }
  }
};
</script>

<style scoped>
.footer-btn {
  border-top: 1px solid #e8eaec;
  display: flex;
  justify-content: end;
}
</style>
